/**
 * AnyAPI is presented as the provider of every API for now - upstream data
 * providers (e.g. the scraping backends) are not credited in customer-facing UI
 * (see CLAUDE.md). Use these in any provider attribution surface.
 */

/** The provider name shown to customers. */
export const BRAND_PROVIDER = 'AnyAPI';

/** Public Discord community invite, linked from the nav, footer, and support. */
export const DISCORD_URL = 'https://discord.gg/WFY2Y9BnWA';
